import honeybadger from 'honeybadger-js';
import React, { useContext, useEffect } from 'react';

import CustomDomainExpirationAlert from './components/CustomDomainExpirationAlert';
import Dashboard from './components/Dashboard';
import DisabledSite from './components/DisabledSite';
import InfoHeader from './components/InfoHeader';

import { useWeddingWebsiteQuery } from './generated/graphql';
import useHoneybadgerSetContext from './helpers/useHoneybadgerSetContext';
import Loading from './Loading';

import {
  useWWSRegistryGuidanceModule,
  CONTROL_VARIANT as REGISTRY_GUIDANCE_CONTROL_VARIANT,
} from './hooks/experiment/useWWSRegistryGuidanceModule';

import Promotion from './components/Promotion';
import { TrackingContext } from './TrackingContext';
import { useReactivateWeddingWebsiteMutation } from './generated/graphql';
import { useSetLastVisitTimestamp } from './hooks/useSetLastVisitTimestamp';

const Main: React.FC = () => {
  const { data, loading } = useWeddingWebsiteQuery();
  useHoneybadgerSetContext(data);
  useSetLastVisitTimestamp();

  const { track, setPageChanged } = useContext(TrackingContext);

  const { variant: registryGuidanceVariant, loading: registryGuidanceExpLoading } = useWWSRegistryGuidanceModule();

  const showRegistryGuidanceControl = registryGuidanceVariant === REGISTRY_GUIDANCE_CONTROL_VARIANT;

  const [reactivateWeddingWebsite] = useReactivateWeddingWebsiteMutation();

  useEffect(() => {
    setPageChanged(prevState => !prevState);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (loading) {
    return <Loading />;
  }

  const onReactivateWebsite = async (e: React.ChangeEvent<HTMLInputElement>) => {
    e.preventDefault();
    try {
      await reactivateWeddingWebsite();
      track('Website Reactivated');
      window.location.reload();
    } catch (error) {
      honeybadger.notify(error, { message: 'Error reactivating wedding website', context: { error } });
    }
  };

  const purchaseDomain = data?.weddingWebsite.purchaseDomain || undefined;
  const { name: domainName, isExpired } = purchaseDomain || {};
  const showViewTrackerCard = data?.weddingWebsite.state === 'published';

  return (
    <div data-testid="main-content">
      {data?.weddingWebsite.state === 'disabled' ? (
        <DisabledSite showReactivateLink reactivateWebsiteCallback={onReactivateWebsite} />
      ) : (
        <>
          <InfoHeader
            hasActiveCustomDomain={Boolean(domainName) || Boolean(isExpired)}
            showViewTrackerCard={showViewTrackerCard}
          />
          <CustomDomainExpirationAlert />
          {!registryGuidanceExpLoading && showRegistryGuidanceControl && <Promotion />}
          <Dashboard />
        </>
      )}
    </div>
  );
};

export default Main;
